import { CalendarPicker } from "components/calendar";
import { useState } from "react";
import { useBookInfContext } from "components/context/bookInfContext";
import Button from "components/button/default";
import { useTranslation } from "react-i18next";
import { useAuthContext } from "components/context/authContext";
import { getMonthList } from "components/calendar/action";
import { alertControl, diffDate } from "util/commAction";
import "./bkCalendar.scss";

type IProps = {
  handleClose(): void;
};

export default function BookInfCalendar({ handleClose }: IProps) {
  const { bookInf, setDates, setDateRange, setIsSearch, onBookInf } =
    useBookInfContext();
  const { t } = useTranslation();
  const { viewPort } = useAuthContext();
  const [now, setNow] = useState(new Date());
  const nextNow = new Date(now.getFullYear(), now.getMonth() + 2, 0);

  const handlePrev = () => {
    const prevNow = new Date(now.getFullYear(), now.getMonth() - 1, 0);
    setNow(prevNow);
  };
  const handleNext = () => {
    const nextNow = new Date(now.getFullYear(), now.getMonth() + 3, 0);
    setNow(nextNow);
  };

  const monthList = getMonthList(24);

  return (
    <div className="">
      {viewPort?.screen === "web" && (
        <div className="flex">
          <button className="btn-icon-prev" onClick={handlePrev} />
          <CalendarPicker now={now} styles={""} />
          <CalendarPicker now={nextNow} styles={""} />
          <button className="btn-icon-next" onClick={handleNext} />
        </div>
      )}
      {viewPort?.screen === "mb" && (
        <div>
          {monthList.map((month) => {
            return <CalendarPicker key={month + ""} now={month} styles="" />;
          })}
        </div>
      )}
      <div className="btn-wrap">
        <button
          className="text-blue-300 font-font-B "
          onClick={() => {
            setDates([]);
            setDateRange([]);
            onBookInf({
              dates: [],
              dateRange: [],
              dateLength: 0,
            });
          }}
        >
          {t("btn_rst_cmm")}
        </button>
        <Button
          text={t("btn_cnf_bk")}
          styels="w-[95px]"
          onClick={() => {
            if (bookInf?.dates.length < 2) {
              return alertControl({
                isOpen: true,
                inner: "체크인, 체크아웃 날짜를 모두 선택하여 주세요.",
              });
            }
            //선택된 날짜로 검색 가능
            setIsSearch(true);
            handleClose();
            const diff = diffDate(bookInf?.dates);
            onBookInf({
              dateLength: diff,
            });
          }}
        />
      </div>
    </div>
  );
}
